export default __webpack_public_path__ + "static/media/bgv.461e24cc.png";